        <template>
  <div
      >
    <b-row
          >
                                    <b-col
                                                                                                >
                            <courses-preview />            </b-col>
                            </b-row>
  </div>
</template>
<script>
/* eslint-disable */
// prettier-ignore
import {
  BRow,
  BCol,
} from 'bootstrap-vue'


                                      import CoursesPreview from '@core/components/courses/courses-preview/CoursesPreview.vue'
                            
export default {
  components: {
    BRow,
    BCol,

                                                          CoursesPreview,
                                          },
  setup() {
    
      },
}
</script>
    